import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

//Logo Carousel 
const logoswiper = new Swiper('.logos', {
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 2,
    freeMode: true,
	breakpoints: {
		1200:{
			slidesPerView: 6,
		},
		992:{
			slidesPerView: 4,
		},
		782:{
			slidesPerView: 3,
		},
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 1200,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.logos-swiper-button-next',
		prevEl: '.logos-swiper-button-prev',
	},
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}

(function($) {
	$(window).scroll(function(){
 		var sticky = $('.navbar'),
      		scroll = $(window).scrollTop();

  		if (scroll > 0) 
			sticky.addClass('small-logo');
  		else 
			sticky.removeClass('small-logo');
	});
})(jQuery);

const parents = document.querySelectorAll('.wp-block-columns');

parents.forEach(parent => {
  const children = parent.children;
  if (children.length === 2) {
    parent.classList.add('has-two-children');
  }
});